/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sellerid2Inputs */

const en__field_sellerid2 = /** @type {(inputs: _Field_Sellerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller`)
};

const de__field_sellerid2 = /** @type {(inputs: _Field_Sellerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäufer`)
};

/**
* | output |
* | --- |
* | "Seller" |
*
* @param {_Field_Sellerid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_sellerid2 = /** @type {((inputs?: _Field_Sellerid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sellerid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_sellerid2(inputs)
	return de__field_sellerid2(inputs)
});
export { _field_sellerid2 as "_field_sellerID" }